import css from 'styled-jsx/css';

export default css`.login-content {
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  left: 0;
  bottom: 0;
  width: 100%;
  min-width: 1200px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 26px 0;
  line-height: 1.4;
  z-index: 100;

  &-flex {
    display: flex;
    background-color: transparent;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
    border-radius: 8px;
    overflow: hidden;
  }
}

.reg-layer-close {
  margin-bottom: 23px;
  cursor: pointer;
  :global(svg) {
    width: 24px;
    height: 24px;
    color: #fff;
  }
}
`